__webpack_require__.p = "/reports-evaluations-details-update/referrals-hub/";